var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24L24 0c13.255 0 24 10.745 24 24z", fill: "#D80027" }),
    React.createElement("path", { d: "M24 24V0C10.745 0 0 10.745 0 24h24z", fill: "#0052B4" }),
    React.createElement("path", { d: "M20.87 14.046l-2.931 1.379 1.56 2.838-3.182-.609-.404 3.216-2.217-2.365-2.217 2.365-.403-3.216-3.183.61 1.561-2.84-2.93-1.378 2.93-1.379-1.56-2.839 3.182.61.403-3.216 2.217 2.365 2.217-2.365.404 3.215 3.182-.609-1.56 2.84 2.93 1.378z", fill: "#F0F0F0" }),
    React.createElement("path", { d: "M13.697 18.513a4.467 4.467 0 1 0 0-8.935 4.467 4.467 0 0 0 0 8.935z", fill: "#0052B4" }),
    React.createElement("path", { d: "M13.696 16.426a2.383 2.383 0 0 1-2.38-2.38 2.383 2.383 0 0 1 2.38-2.38 2.383 2.383 0 0 1 2.38 2.38 2.383 2.383 0 0 1-2.38 2.38z", fill: "#F0F0F0" })
  );
});